import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { FormaPago } from '@p-p-portafolio/interfaces/formaPago';
import { SwalService } from '@shared/utils/swal.service';
import { FormaPagoService } from '@p-p-portafolio/services/formaPago.service';
import Swal from 'sweetalert2';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-formaPago',
  templateUrl: './formaPago.component.html',
  providers: [MessageService]
})
export class FormaPagoComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedFormaPago: FormaPago | null = null;
  dataSource: FormaPago[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns: Column[] = [
    { field: 'clave', header: 'Clave Forma de Pago' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'pedir_Referencia', header: 'Pedir Referencia' },
    { field: 'efectivo', header: 'Efectivo' },
    { field: 'pedir_Autorizacion', header: 'Pedir Autorización' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private messageService: MessageService,
    private formaPagoService: FormaPagoService,
    private swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    this.formaPagoService.getAll().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.dataSource = response.data;
        } else {
          this.dataSource = [];
          this.messageService.add({
            severity: 'warn',
            summary: 'Advertencia',
            detail: 'No se pudieron cargar los datos'
          });
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar formas de pago:', err);
        this.swalService.error('Error al cargar los datos');
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedFormaPago = null;
    this.displayDialog = true;
  }

  openUpdate(row: FormaPago): void {
    this.selectedFormaPago = { ...row };
    this.displayDialog = true;
  }

  onDialogClosed(): void {
    this.selectedFormaPago = null;
    this.displayDialog = false;
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.read();
  }

  openDelete(model: FormaPago) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar la forma de pago ${model.clave}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.formaPagoService.delete(model).subscribe({
          next: (response) => {
            if (response.success) {
              this.swalService.success('Eliminado correctamente');
              this.read();
            } else {
              this.swalService.error(response.errors[0]);
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this.swalService.error('Error al eliminar');
            this.loading = false;
          }
        });
      }
    });
  }
}
